import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-guide-enterprise',
  templateUrl: './guide-enterprise.component.html',
  styleUrls: ['./guide-enterprise.component.scss']
})
export class GuideEnterpriseComponent implements OnInit {

  constructor(private router:Router, public route:ActivatedRoute) {
    console.log('router', router);
    console.log('route', route);
  }

  ngOnInit() {
  }

}
